import styled from 'styled-components';
import { Draggable } from '@hello-pangea/dnd';

import SmallTileComponent from './SmallTileComponent.jsx';

const SmallDraggableTileContainer = styled.div`
  margin-right: 16px;
`;

const SmallDraggableTile = ({
  id,
  index,
  thumbnail,
  headline,
  fullyAssembled,
  planDate,
  loading,
  ignored,
  status,
  editPath,
  embedVideo,
  ribbonTagName,
  ribbonTagColor,
  tileShowPath,
  audienceColor,
}) => (
  <Draggable
    draggableId={`${id}`}
    index={index}
    isDragDisabled={status === 'user_submitted'}
  >
    {provided => (
      <SmallDraggableTileContainer
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
      >
        <SmallTileComponent
          id={id}
          headline={headline}
          thumbnail={thumbnail}
          fullyAssembled={fullyAssembled}
          planDate={planDate}
          status={status}
          loading={loading}
          draggable={true}
          ignored={ignored}
          editPath={editPath}
          embedVideo={embedVideo}
          ribbonTagName={ribbonTagName}
          ribbonTagColor={ribbonTagColor}
          tileShowPath={tileShowPath}
          audienceColor={audienceColor}
          currentTab="plan"
        />
      </SmallDraggableTileContainer>
    )}
  </Draggable>
);

export { SmallDraggableTile };
